<template>
  <div class="sweep">
    <div style="float: left">
      <span>状态:</span>
      <el-select
        :value="queryParams.status"
        @change="handleSweepStatusChange($event)"
        placeholder="状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="创建-待审核" value="0"></el-option>
        <el-option label="正在执行中" value="1"></el-option>
        <el-option label="成功" value="2"></el-option>
        <el-option label="失败" value="3"></el-option>
        <el-option label="没有找到币种配置信息" value="4"></el-option>
        <el-option label="审核通过，等待执行" value="5"></el-option>
      </el-select>
    </div>
    <div class="preview-opration">
      <el-button
        style="margin-left: 30px"
        icon="el-icon-plus"
        type="danger"
        @click="openCreateSweepDialog"
        >新增
      </el-button>
    </div>
    <!-- <div style="width: 100%;float: left;margin-top: 10px">
            <el-input placeholder="SWEEP_ERC20_GAS_LIMIT_RATIO" v-model="gasLimitRatio"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="updateGasLimitRatio">修改</el-button>
            <span style="color: red">（SWEEP_ERC20_GAS_LIMIT_RATIO比列值，填整数）</span>
        </div> -->
    <div class="sweep-list">
      <el-table
        class="sweep-table"
        border
        :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
        :data="dataList"
        :row-key="() => Math.random()"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="coinType" label="币种类型"></el-table-column>
         <el-table-column
          prop="amount"
          label="数量"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="fromAddress"
          label="转出地址"
          show-overflow-tooltip
        ></el-table-column>
         <el-table-column
          prop="toAddress"
          label="转入地址"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="hash"
          label="hash"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="config"
          label="配置字符串"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="description"
          label="描述"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status | formatStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              type="danger"
              @click="retryRecord(scope.row.id)"
              v-if="scope.row.status == 3 || scope.row.status == 4"
              >重试
            </el-button>
            <el-button
              type="success"
              @click="reviewRecord(scope.row.id)"
              v-if="scope.row.status == 0 && rightsContains('REVIEW_REFUND_COIN')"
              >审核通过
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 30px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryParams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="增加"
      :visible.sync="dialogVisible"
      width="60%"
      @close="clearData"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="币种">
          <el-autocomplete
            class="inline-input"
            v-model="addData.coinType"
            :fetch-suggestions="querySearch"
            placeholder="请输入币种"
            @select="handleSelect"
            @keyup.native.enter="handleSearch"
          >
            <i
              class="el-icon-close el-input__icon"
              slot="suffix"
              @click="cleanSearchCoin"
              style="cursor: pointer"
            >
            </i>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number
            placeholder="请输入数量"
            v-model="addData.amount"
            style="width: 80%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="转出地址">
          <el-input
            placeholder="请输入转出地址"
            v-model="addData.fromAddress"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="转入地址">
          <el-input
            placeholder="请输入转入地址"
            v-model="addData.toAddress"
            style="width: 80%"
          ></el-input>
        </el-form-item>

        <el-form-item label="合约地址">
          <el-input
            placeholder="请输入合约地址"
            v-model="addData.config.contractAddress"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="API Precision">
          <el-input
            placeholder="API Precision"
            v-model="addData.config.apiPrecision"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" :loading="loading" @click="addSweepRecord"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import api from "./api";
import { RIGHTS_TYPE } from "../../common/constant";
import { mapState } from 'vuex';

export default {
  name: "Sweep",
  computed: {
    ...mapState(["userInfo", "userRights"])
  },
  data() {
    return {
      dataList: [], //数据列表
      total: 0, //总条数
      queryParams: {
        //查询参数
        page: 1,
        size: 10,
        status: "",
      },
      gasLimitRatio: 0,
      dialogVisible: false, //对话框是否显示
      loading: false,
      addData: {
        coinType: "",
        fromAddress: "",
        toAddress: "",
        amount: "",
        config: { coinType: "", contractAddress: "", apiPrecision: "" },
      },
      coinTypes: [],
    };
  },
  filters: {
    formatStatus(state) {
      switch (state) {
        case 0:
          return "创建-待审核";
        case 1:
          return "正在执行中";
        case 2:
          return "成功";
        case 3:
          return "失败";
        case 4:
          return "没有找到币种配置信息";
        case 5:
          return "审核通过，等待执行";
      }
    },
  },
  methods: {
    rightsContains(r) {
      let rights = this.userRights.split(",") || [];
      return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
    },
    getAllRecord(query) {
      api.getAllRecord(query).then(({ data }) => {
        this.dataList = data.list;
        this.total = data.totalCount;
      });
    },
    getAllSupportCoin() {
      api.getAllSupportCoin().then(({ data }) => {
        this.coinTypes = data;
      });
    },
    handleSizeChange(val) {
      this.queryParams.size = val;
      this.getAllRecord(this.queryParams);
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getAllRecord(this.queryParams);
    },
    handleSweepStatusChange(status) {
      this.queryParams.status = status;
      this.getAllRecord(this.queryParams);
    },
    openCreateSweepDialog() {
      this.getAllSupportCoin();
      this.dialogVisible = true;
    },
    retryRecord(id) {
      this.$confirm("确认重试吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          api.retryRecord({ id: id }).then(({ data }) => {
            this.$message.success("操作成功!");
            this.getAllRecord(this.queryParams);
          });
        })
        .catch(() => {});
    },
    reviewRecord(id) {
      this.$confirm("确认审核通过吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          api.reviewRecord({ id: id }).then(({ data }) => {
            this.$message.success("操作成功!");
            this.getAllRecord(this.queryParams);
          });
        })
        .catch(() => {});
    },
    formatCheck(addr) {
      return /^(0x|0X){1}[0-9a-fA-F]{40}$/.test(addr);
    },
    addSweepRecord() {
      if (this.addData.coinType == "") {
        this.$message.error("请选择币种");
        return;
      }

      if (this.addData.amount == "") {
        this.$message.error("请选择币种");
        return;
      }

      if (this.addData.fromAddress == "") {
        this.$message.error("请添加转出地址");
        return;
      }

      if (!this.formatCheck(this.addData.fromAddress)) {
        this.$message.error("转出地址格式不正确！");
        return;
      }

      if (this.addData.toAddress == "") {
        this.$message.error("请添加转入地址");
        return;
      }

      if (!this.formatCheck(this.addData.toAddress)) {
        this.$message.error("转入地址格式不正确！");
        return;
      }
      // if (this.addData.config.contractAddress == "") {
      //     this.$message.error('请填入合约地址');
      //     return;
      // }
      // if (this.addData.config.apiPrecision == "") {
      //     this.$message.error('请填入API Precision');
      //     return;
      // }
      this.loading = true;
      this.addData.config.coinType = this.addData.coinType;
      api.addRecord(this.addData).then(({ data }) => {
        this.$message.success("添加成功!");
        this.getAllRecord(this.queryParams);
        this.dialogVisible = false;
        this.loading = false;
      });
    },

    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.coinTypes;
      results = queryString
        ? coinList.filter(this.createFilter(queryString))
        : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v,
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.coinTypes;
      return (tempData) => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    cleanSearchCoin() {
      this.addData.coinType = "";
    },
    handleSearch() {},
    handleSelect() {},
    clearData() {
      this.addData = {
        coinType: "",
        fromAddress: "",
        toAddress: "",
        amount: "",
        config: { coinType: "", contractAddress: "", apiPrecision: "" },
      };
      this.coinTypes = [];
      this.loading = false;
    },
  },
  created() {
    this.getAllRecord(this.queryParams);
  },
};
</script>

<style lang="less" scoped>
.sweep {
  .preview-opration {
    float: right;
  }

  .sweep-list {
    border: 1px solid #f2ece2;
    clear: both;
    width: 100%;
    .sweep-table {
      margin-top: 30px;
    }
  }
}
</style>

